var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleWorkSpaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.0001,
    r: 16,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_784_9593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 16.2031C24.9991 15.6326 24.9504 15.0632 24.8544 14.5005H16.1953V17.8823H21.1533C21.0443 18.427 20.8255 18.9449 20.5098 19.4059C20.194 19.8669 19.7875 20.2617 19.3141 20.5673V22.8172H22.2713C24.0037 21.2498 24.9999 18.94 24.9999 16.2031Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1954 24.9997C18.6783 24.9997 20.7549 24.1896 22.272 22.8172L19.3148 20.5672C18.3871 21.1552 17.301 21.4586 16.196 21.4383C15.0466 21.4244 13.9306 21.0579 13.0053 20.3903C12.08 19.7228 11.3921 18.7878 11.0384 17.7173H7.98853V20.0348C8.75104 21.5262 9.92254 22.7805 11.3719 23.6573C12.8213 24.5342 14.4915 24.999 16.1954 24.9997Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0384 17.7174C10.8441 17.1648 10.7459 16.5843 10.7479 15.9999C10.7498 15.4158 10.8481 14.8359 11.039 14.2824V11.965H7.98852C7.33872 13.215 7 14.5976 7 16C7 17.4025 7.33872 18.7851 7.98852 20.0351L11.0384 17.7174Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1954 10.5625C17.5058 10.5415 18.7721 11.026 19.7205 11.9113L22.3412 9.34637C20.6814 7.81316 18.4775 6.97175 16.1954 7.00002C14.4915 7.00076 12.8213 7.46557 11.3719 8.34242C9.92254 9.21928 8.75104 10.4736 7.98853 11.965L11.0384 14.2824C11.3922 13.2122 12.0802 12.2776 13.0053 11.6103C13.9305 10.9429 15.0462 10.5765 16.1954 10.5625Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_9593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7.00006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWorkSpaceIcon);
export default __webpack_public_path__ + "static/media/googleWorkSpaceIcon.723a7bf19195ebc5a7d61740b5bd571e.svg";
export { ForwardRef as ReactComponent };